import { common as c, operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'feature-metrics-hover',
    productArea: PRODUCT_AREAS.ANALYTICS,
    subProductArea: SUB_PRODUCT_AREAS.TAG_HOVER_CARDS,
    responseFormat: 'row',
    build: ({
        id,
        timeSeries,
        includeAnonymous,
    }: {
        id: string;
        timeSeries: c.TimeSeries;
        includeAnonymous?: string | boolean | null;
    }) => {
        return o.pipeline(
            o.sources.featureEvents({
                featureId: id,
                timeSeries,
            }),
            o.identified(includeAnonymous || undefined),
            o.reduce({
                totalEvents: o.sum('numEvents'),
                uniqueVisitors: o.count('visitorId'),
                uniqueAccounts: o.countIf('accountId', 'accountId != ""'),
            }),
        );
    },
};
